module.exports = __webpack_public_path__ + "static/img/bonus.36483ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bonus.png
// module id = z6LO
// module chunks = 3